// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3l77m","h1":"Header_h1__L2bb5","ul":"Header_ul__RJ4o0","navLink":"Header_navLink__Q-ic9"};